/**
 *  Search form autocomplete
 *
 *  Заменить на свою реализацию
 */
interface SearchSuggestion{
    data: string,
    value: string,
    view: string,
    id?: number
}
interface SearchSuggestionAnswer {
    status: string,
    warning: string,
    error: string,
    total: number,
    total_count: number,
    categories: SearchSuggestion[],
    suggestions: SearchSuggestion[],
    all_results: string
}

document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.querySelector<HTMLInputElement>(".search__input");
    const autocompleteBox = document.getElementById("searchAutocomplete");
    const clearButton = document.querySelector<HTMLButtonElement>(".search__clear");

    if (!searchInput || !autocompleteBox || !clearButton) return;

    let debounceTimer: number;
    let abortController: AbortController | null = null;
    let displayedQuery = "";
    let displayedTotal = 0;
    let displayedProductIds: number[] = [];

    const updateClearButton = (): void => {
        clearButton.hidden = searchInput.value.length === 0;
    };

    updateClearButton();

    searchInput.addEventListener("input", () => {
        const query = searchInput.value.trim();
        displayedQuery = "";
        updateClearButton();
        clearTimeout(debounceTimer);

        // Автопоиск работает с первого символа. Ограничение query.length < 3 отключено.
        if (query.length === 0) {
            abortController?.abort();
            autocompleteBox.innerHTML = "";
            autocompleteBox.style.display = "none";
            return;
        }

        // Устанавливаем задержку перед отправкой запроса
        debounceTimer = window.setTimeout(() => {
            fetchSuggestions(query);
        }, 300);
    });

    searchInput.addEventListener("focus", () => {
        const query = searchInput.value.trim();
        if (query.length === 0) {
            return;
        }
        if (autocompleteBox.innerHTML !== '' && displayedQuery === query) {
            autocompleteBox.style.display = 'block';
            return;
        }

        fetchSuggestions(query);
    });

    clearButton.addEventListener("click", () => {
        clearTimeout(debounceTimer);
        abortController?.abort();
        searchInput.value = "";
        autocompleteBox.innerHTML = "";
        autocompleteBox.style.display = "none";
        updateClearButton();
        searchInput.focus();
    });

    async function fetchSuggestions(query: string): Promise<void> {
        // Отменяем предыдущий запрос, если пользователь продолжает ввод
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();

        try {
            const response = await fetch(`/search/auto?c=0&query=${encodeURIComponent(query)}`, {
                signal: abortController.signal,
            });

            if (!response.ok) {
                throw new Error("Ошибка при получении данных");
            }

            const answer: SearchSuggestionAnswer = await response.json();
            if (searchInput?.value.trim() !== query) return;

            const suggestions = answer.suggestions ?? [];
            updateAutocomplete(answer.categories ?? [], suggestions, answer.all_results ?? "");
            displayedQuery = query;
            displayedTotal = answer.total_count ?? 0;
            displayedProductIds = suggestions
                .map(item => item.id ?? 0)
                .filter(id => Number.isSafeInteger(id) && id > 0);
        } catch (error) {
                console.log(error);
                
            if (error instanceof Error && error.name !== "AbortError") {
                console.error("Ошибка загрузки подсказок:", error);
            }
        }
    }

    function updateAutocomplete(
        categories: SearchSuggestion[],
        suggestions: SearchSuggestion[],
        allResults: string
    ): void {
        if (!autocompleteBox) {
            return
        }
        if (!categories.length && !suggestions.length && !allResults) {
            autocompleteBox.style.display = "none";
            return;
        }

        autocompleteBox.innerHTML = [...categories, ...suggestions]
            .map(item => item.view)
            .join("") + allResults;

        autocompleteBox.style.display = "block";
    }

    autocompleteBox.addEventListener("click", (event: MouseEvent) => {
        if (!(event.target instanceof Element)) return;

        const link = event.target.closest<HTMLAnchorElement>("a.autocomplete__item");
        if (!link || !autocompleteBox.contains(link) || displayedQuery !== searchInput.value.trim()) return;

        const productId = link.dataset.productId;
        const categoryName = link.dataset.categoryName;
        if (!productId && !categoryName) return;

        const url = autocompleteBox.dataset.clickUrl;
        const token = autocompleteBox.dataset.clickToken;
        if (!url || !token) return;

        const data = new FormData();
        data.append("_token", token);
        data.append("query", displayedQuery);
        data.append("total", String(displayedTotal));
        displayedProductIds.forEach(id => data.append("product_ids[]", String(id)));
        data.append("selected_type", productId ? "product" : "category");
        data.append("selected", productId || categoryName || "");

        if (!navigator.sendBeacon || !navigator.sendBeacon(url, data)) {
            fetch(url, { method: "POST", body: data, credentials: "same-origin", keepalive: true })
                .catch(() => {});
        }
    });

    document.addEventListener("click", (event: MouseEvent) => {
        if (!searchInput.contains(event.target as Node)
            && !clearButton.contains(event.target as Node)
            && !autocompleteBox.contains(event.target as Node)) {
            autocompleteBox.style.display = "none";
        }
    });
    
    document.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            autocompleteBox.style.display = "none";
        }
    });
});
